import { render, staticRenderFns } from "./ActivateCode.vue?vue&type=template&id=74a000ca&scoped=true&"
import script from "./ActivateCode.vue?vue&type=script&lang=js&"
export * from "./ActivateCode.vue?vue&type=script&lang=js&"
import style0 from "./ActivateCode.vue?vue&type=style&index=0&id=74a000ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a000ca",
  null
  
)

export default component.exports